import { observer } from 'mobx-react-lite';
import type { FC } from 'react';

import { FavoritesPagination } from 'components/FavoritesPagination';
import { SearchResultsPagination } from 'components/SearchResultsPagination';
import { useStore } from 'hooks/useStore';
import { tabIds } from 'store/UIStore/UIStore';

import css from './StickyPagination.module.css';

const StickyPagination: FC = () => {
  const { ui, favorites } = useStore();

  const shouldShowSearchPagination =
    ui.totalPages > 1 && [tabIds.search, tabIds.savedFilters, tabIds.history, tabIds.byTrucks].includes(ui.activeTab);

  const shouldShowFavoritesPagination = favorites.totalPages > 1 && ui.activeTab === tabIds.favorites;

  switch (true) {
    case shouldShowSearchPagination:
      return <SearchResultsPagination className={css.pagination} tooltip={false} />;
    case shouldShowFavoritesPagination:
      return <FavoritesPagination className={css.pagination} />;
    default:
      return null;
  }
};

const connected = observer(StickyPagination);

export { connected as StickyPagination };
